import { Trans, useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { getErrorMessage } from '@tshared/oapi/req/models'
import { App, Button, Result, Typography } from 'antd'
import { z } from 'zod'

import { useMobileConfirmEmailChangeMutation } from '@/apis/mobile-auth.api'

import logo from '../-assets/logo.svg'

const { Title } = Typography

export const Route = createFileRoute('/auth/confirm-email-change/')({
  component: ConfirmEmailChangePage,
  validateSearch: z.object({
    token: z.string().optional(),
  }),
})

function ConfirmEmailChangePage() {
  const { t } = useLingui()
  const { message } = App.useApp()
  const { token } = Route.useSearch()
  const confirmMutation = useMobileConfirmEmailChangeMutation()
  const navigate = useNavigate()

  if (!token) {
    return <Result status="error" title={t`Invalid or expired confirmation link`} />
  }

  const onConfirm = async () => {
    try {
      await confirmMutation.mutateAsync({ token })
      void message.success(t`Email changed successfully`)
      void navigate({
        to: '/auth/success',
        search: {
          success_type: 'email_change_success',
        },
      })
    } catch (error) {
      void message.error(
        getErrorMessage(error as Error, t`Email change confirmation failed`) ??
          t`Email change confirmation failed`,
      )
    }
  }

  return (
    <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto', padding: '32px 0' }}>
      <div className="flex justify-center">
        <img src={logo} alt="" className="mb-8" />
      </div>
      <Title level={1} className="mb-1">
        <Trans>Confirm Email Change</Trans>
      </Title>
      <p className="mb-6 text-sm text-gray-500">
        <Trans>Click the button below to confirm the new email address for your account</Trans>
      </p>

      <Button
        type="primary"
        onClick={() => void onConfirm()}
        loading={confirmMutation.isPending}
        block
        size="large"
      >
        <Trans>Confirm Email Change</Trans>
      </Button>
    </div>
  )
}
